<template>
    <h1>500</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>